<div class="sop-form-content-container">
    <div class="form-fields-container" [formGroup]="sopDetailsForm">
        <div class="details-input-field">
            <span>SOP Name</span>
            <input matInput formControlName="name" placeholder="SOP Name" readonly>
        </div>
        <div class="details-input-field">
            <span>Part Number</span>
            <input matInput formControlName="partNo" placeholder="Part Number" readonly
                [ngClass]="{ 'input-error': sopDetailsForm.get('partNo')?.hasError('required') }">
        </div>
        <!-- <div class="details-input-field">
            <span>Station</span>
            <input matInput formControlName="station" placeholder="Enter Station"
                [ngClass]="{ 'input-error': sopDetailsForm.get('station')?.hasError('required') }">
        </div> -->
    </div>
    <div class="video-steps-container">
        <div class="video-instructions-container">
            <div class="video-field-container">
                <span>Video</span>
                <div *ngIf="formData?.videoProcessing === 'COMPLETED'; else showConditionalContent"
                    class="video-container">
                    <video #target class="video-js vjs-default-skin" controls preload="auto" width="100%" height="100%"
                        style="object-fit: contain; width: 100%; height: 100%;">
                    </video>
                </div>
                <ng-template #showConditionalContent>
                    <div *ngIf="formData?.videoProcessing === 'IN-PROGRESS'; else checkIfFailed"
                        class="video-container">
                        <mat-spinner diameter="40"></mat-spinner>
                        <span class="ms-2">{{'Processing video...'}}</span>
                    </div>
                </ng-template>
                <ng-template #checkIfFailed>
                    <div *ngIf="formData?.videoProcessing === 'FAILED';" class="video-container">
                        <span class="text-danger">⚠️ Video processing failed.</span>
                    </div>
                </ng-template>
            </div>
            <div class="custom-rich-editor-cont" *ngIf="selectedInstructions">
                <div id="custom-toolbar">
                </div>
                <div class="toggle-container-wrapper">
                    <span>Instructions</span>
                    <div class="toggle-container">
                        <div class="toggle-button" [ngClass]="{'active': !languageControl.value}"
                            (click)="languageControl.setValue(false)">
                            English
                        </div>
                        <div class="toggle-button" [ngClass]="{'active': languageControl.value}"
                            (click)="languageControl.setValue(true)">
                            Tamil
                        </div>
                    </div>
                </div>
                <quill-editor #quillEditor [modules]="editorModules" [(ngModel)]="selectedInstructions"
                    [readOnly]="true" placeholder="Type your Instructions" style="height: 100%;">
                </quill-editor>
            </div>
        </div>
        <div class="steps-main-container" *ngIf="sopSteps?.length > 0 && sopStepForm?.get('steps')"
            [formGroup]="sopStepForm">
            <span>Steps</span>
            <div class="steps-scrollable-container" formArrayName="steps">
                <div class="step-card-container" *ngFor="let step of steps.controls; let i = index" [formGroupName]="i">
                    <div class="header">
                        <div class="input-field">
                            <span>Work Sequence</span>
                            <input matInput formControlName="stepName" placeholder="Enter Sequence Name" readonly
                                [ngClass]="{ 'input-error': step.get('stepName')?.hasError('required') && step.get('stepName')?.touched}">
                            <span class="error-msg"
                                *ngIf="step.get('stepName')?.hasError('required') && step.get('stepName')?.touched">
                                Work Sequence is required.</span>
                        </div>
                        <mat-icon matTooltip="Play step" color="primary" class="play-icon"
                            (click)="playStep(step)">play_circle_filled</mat-icon>
                    </div>
                    <!-- <div class="custom-rich-editor-cont">
                            <div id="custom-toolbar">
                            </div>
                            <span>Instructions</span>
                            <quill-editor #quillEditor formControlName="instructions" [modules]="editorModules"
                                [readOnly]="true" placeholder="Type your Instructions" style="height: 100%;">
                            </quill-editor>
                        </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- <ng-template #loading>
    <div class="loader-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="ms-2">Fetching SOP details</span>
    </div>
</ng-template> -->



    <!-- <div class="sop-right-column-container">
    <ng-container>
        <div class="sop-details-container" *ngIf="isCreatingNewSop" [formGroup]="sopDetailsForm">
            <div class="fields-container">
                <div class="details-input-field">
                    <span>SOP Name</span>
                    <input matInput formControlName="name" placeholder="SOP Name" readonly>
                </div>
                <div class="details-input-field">
                    <span>Part Number</span>
                    <input matInput formControlName="partNo" placeholder="Part Number" readonly
                        [ngClass]="{ 'input-error': sopDetailsForm.get('partNo')?.hasError('required') }">
                </div>
                <div class="details-input-field">
                    <span>Station</span>
                    <input matInput formControlName="station" placeholder="Enter Station"
                        [ngClass]="{ 'input-error': sopDetailsForm.get('station')?.hasError('required') }">
                </div>
            </div>

            <div class="video-field-container">
                <span>Video</span>
                <div *ngIf="formData?.videoProcessing === 'COMPLETED'; else showConditionalContent"
                    class="video-container mt-3 mb-3 container d-flex align-items-center justify-content-center">
                    <video #target class="video-js vjs-default-skin" controls preload="auto" width="640" height="264">
                    </video>
                </div>
                <ng-template #showConditionalContent>
                    <div *ngIf="formData?.videoProcessing === 'IN-PROGRESS'; else checkIfFailed"
                        class="video-container justify-content-center">
                        <mat-spinner diameter="40"></mat-spinner>
                        <span class="ms-2">{{'Processing video...'}}</span>
                    </div>
                </ng-template>
                <ng-template #checkIfFailed>
                    <div *ngIf="formData?.videoProcessing === 'FAILED';" class="video-container">
                        <span class="text-danger">⚠️ Video processing failed.</span>
                    </div>
                </ng-template>
            </div>
        </div>
        <div class="sop-instructions-container"
            *ngIf="isCreatingNewSop && sopSteps?.length === 0; else showStepsContainer">
            <div class="instructions">
                <span class="heading">Instructions</span>
                <div class="sop-instructions-content-container">
                    <ul>
                        <li>
                            <strong>Enter</strong> the <span class="highlight">SOP Name</span> and <span
                                class="highlight">Part
                                Number</span> in the input fields.
                        </li>
                        <li>
                            <strong>Upload</strong> the video corresponding to the selected part number.
                        </li>
                        <li>
                            Wait till the video gets uploaded and processed.
                        </li>
                        <li>
                            <strong>Click on the video timeline</strong> to add step markers. Each click creates a new
                            SOP
                            step.
                        </li>
                        <li>
                            <strong>Add detailed instructions</strong> once step is created
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <ng-template #showStepsContainer>
            <div class="steps-main-container" *ngIf="sopSteps?.length > 0 && sopStepForm?.get('steps')"
                [formGroup]="sopStepForm">
                <div class="steps-scrollable-container" formArrayName="steps">
                    <div class="step-card-container" *ngFor="let step of steps.controls; let i = index"
                        [formGroupName]="i">
                        <div class="header">
                            <div class="input-field">
                                <span>Work Sequence</span>
                                <input matInput formControlName="stepName" placeholder="Enter Sequence Name" readonly
                                    [ngClass]="{ 'input-error': step.get('stepName')?.hasError('required') && step.get('stepName')?.touched}">
                                <span class="error-msg"
                                    *ngIf="step.get('stepName')?.hasError('required') && step.get('stepName')?.touched">
                                    Work Sequence is required.</span>
                            </div>
                            <mat-icon matTooltip="Play step" color="primary" class="play-icon"
                                (click)="playStep(step)">play_circle_filled</mat-icon>
                        </div>
                        <div class="custom-rich-editor-cont">
                            <div id="custom-toolbar">
                            </div>
                            <span>Instructions</span>
                            <quill-editor #quillEditor formControlName="instructions" [modules]="editorModules"
                                [readOnly]="true" placeholder="Type your Instructions" style="height: 100%;">
                            </quill-editor>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-container>
</div> -->